import { render, staticRenderFns } from "./StationDetail.vue?vue&type=template&id=5b3a3fd9&scoped=true"
import script from "./StationDetail.vue?vue&type=script&lang=js"
export * from "./StationDetail.vue?vue&type=script&lang=js"
import style0 from "./StationDetail.vue?vue&type=style&index=0&id=5b3a3fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a3fd9",
  null
  
)

export default component.exports